// Arabic (العربية) translations — Modern Standard Arabic (MSA)
// Curated for UAE Facilities Management industry usage.
// Formal business register. No colloquialisms.
// Reviewed terminology: إدارة المرافق (FM), الصيانة الوقائية (PPM), شكوى (complaint),
// مستأجر (tenant), مزود خدمة (service provider), أمر عمل (work order).

const ar = {
  // Common
  "common.cancel": "إلغاء",
  "common.loggedInAs": "تم تسجيل الدخول كـ",
  "common.allModules": "جميع الوحدات",
  "common.save": "حفظ",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.search": "بحث",
  "common.loading": "جارٍ التحميل...",
  "common.actions": "الإجراءات",
  "common.status": "الحالة",
  "common.name": "الاسم",
  "common.email": "البريد الإلكتروني",
  "common.phone": "الهاتف",
  "common.role": "الدور",
  "common.active": "نشط",
  "common.blocked": "محظور",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.submit": "إرسال",
  "common.create": "إنشاء",
  "common.add": "إضافة",
  "common.update": "تحديث",
  "common.welcome": "مرحبًا",
  "common.signOut": "تسجيل الخروج",
  "common.signIn": "تسجيل الدخول",
  "common.demo": "نسخة تجريبية",
  "common.readOnly": "للقراءة فقط",
  "common.welcomeBack": "مرحبًا بعودتك",
  "common.role": "الدور",
  "common.priority": "الأولوية",
  "common.category": "الفئة",
  "common.building": "المبنى",
  "common.assignedTo": "المُسند إلى",
  "common.created": "تاريخ الإنشاء",
  "common.unassigned": "غير مُسند",
  "common.all": "الكل",
  "common.portfolio": "المحفظة الكاملة",
  "common.allBuildings": "جميع المباني (المحفظة)",

  // Dashboard
  "dash.welcome": "مرحبًا بعودتك، {{name}}!",
  "dash.subtitle": "إليك ما يحدث في مرافقك اليوم",
  "dash.totalBuildings": "إجمالي المباني",
  "dash.openComplaints": "الشكاوى المفتوحة",
  "dash.inProgress": "قيد التنفيذ",
  "dash.resolvedToday": "تم الحل اليوم",
  "dash.pendingPpm": "مهام الصيانة الوقائية المعلقة",
  "dash.overdueTasks": "المهام المتأخرة",
  "dash.lowStock": "عناصر مخزون منخفضة",
  "dash.expiringCerts": "شهادات قاربت على الانتهاء",
  "dash.complaintsByStatus": "الشكاوى حسب الحالة",
  "dash.complaintsByCategory": "الشكاوى حسب الفئة",
  "dash.perBuilding": "الشكاوى — تفصيل حسب المبنى",
  "dash.utilityTrend": "اتجاه استهلاك المرافق",

  // Complaints
  "comp.title": "الشكاوى والبلاغات",
  "comp.subtitle": "إدارة شكاوى المستأجرين وبلاغات الصيانة",
  "comp.new": "شكوى جديدة",
  "comp.status.open": "مفتوحة",
  "comp.status.assigned": "مُسندة",
  "comp.status.in_progress": "قيد التنفيذ",
  "comp.status.resolved": "تم الحل",
  "comp.status.closed": "مُغلقة",
  "comp.priority.low": "منخفضة",
  "comp.priority.medium": "متوسطة",
  "comp.priority.high": "عالية",
  "comp.priority.urgent": "عاجلة",
  "comp.category.hvac": "تكييف وتبريد",
  "comp.category.plumbing": "السباكة",
  "comp.category.electrical": "كهرباء",
  "comp.category.maintenance": "صيانة عامة",
  "comp.category.security": "أمن",
  "comp.category.cleaning": "نظافة",
  "comp.category.other": "أخرى",

  // Buildings
  "bldg.title": "المباني",
  "bldg.subtitle": "إدارة محفظة المباني الخاصة بشركتك",
  "bldg.add": "إضافة مبنى",
  "bldg.floors": "الطوابق",
  "bldg.units": "الوحدات",
  "bldg.totalArea": "المساحة الإجمالية",

  // PPM Tasks
  "ppm.title": "مهام الصيانة الوقائية",
  "ppm.subtitle": "مهام الصيانة الوقائية وتتبع مواعيد الاستحقاق",
  "ppm.new": "مهمة صيانة وقائية جديدة",

  // Schedules
  "sched.title": "الجداول الزمنية للأعمال",
  "sched.subtitle": "جداول متكررة مع تذكيرات وتجديد تلقائي",
  "sched.new": "جدول جديد",

  // Assets
  "asset.title": "سجل الأصول",
  "asset.subtitle": "قائمة المعدات مع رموز QR وتتبع الصيانة",
  "asset.add": "إضافة أصل",
  "asset.scanQR": "مسح رمز QR",
  "asset.stopScan": "إيقاف المسح",
  "asset.downloadPDF": "تحميل PDF",

  // Suppliers
  "supp.title": "الموردون",
  "supp.subtitle": "مزودو الخدمات ودليل الموردين",
  "supp.add": "إضافة مورد",

  // Tenants
  "tenant.title": "المستأجرون",
  "tenant.subtitle": "دليل المستأجرين ومعلومات عقود الإيجار",
  "tenant.add": "إضافة مستأجر",

  // Staff
  "staff.title": "دليل الموظفين",
  "staff.subtitle": "أعضاء فريق إدارة المرافق ومعلومات الاتصال",
  "staff.add": "إضافة موظف",

  // Certificates
  "cert.title": "الشهادات القانونية",
  "cert.subtitle": "شهادات الامتثال والتجديدات ومتابعة انتهاء الصلاحية",
  "cert.add": "إضافة شهادة",

  // Notices
  "notice.title": "التعميمات والإشعارات",
  "notice.subtitle": "إعلانات على مستوى الشركة والتعاميم",
  "notice.new": "نشر تعميم",

  // Contacts
  "contact.title": "دليل جهات الاتصال",
  "contact.subtitle": "جهات اتصال الطوارئ والأشخاص الرئيسيون",
  "contact.add": "إضافة جهة اتصال",

  // Stock
  "stock.title": "المخزون والعهد",
  "stock.subtitle": "المواد وقطع الغيار والمستهلكات",
  "stock.totalValue": "القيمة الإجمالية",
  "stock.registerPDF": "سجل المخزون PDF",
  "stock.newItem": "عنصر جديد",
  "stock.auditLog": "سجل الحركة",
  "stock.unitCost": "تكلفة الوحدة",
  "stock.value": "القيمة",

  // Stock Movements
  "mv.title": "سجل تدقيق حركة المخزون",
  "mv.subtitle": "سجل تدقيق كامل لكل عمليات الاستلام والصرف والتعديل والإرجاع — لأغراض المطابقة والامتثال.",
  "mv.manual": "حركة يدوية",
  "mv.auditPDF": "تقرير التدقيق PDF",
  "mv.movements": "الحركات",
  "mv.totalIn": "الإجمالي الوارد (القيمة)",
  "mv.totalOut": "الإجمالي الصادر (القيمة)",
  "mv.netChange": "صافي التغيير",
  "mv.noData": "لا توجد حركات بعد",

  // AMC
  "amc.title": "عقود الصيانة الشاملة",
  "amc.subtitle": "عقود الصيانة السنوية ومتابعة نطاق العمل — ربط مهام الصيانة الوقائية لتقييم الامتثال.",
  "amc.new": "عقد جديد",
  "amc.compliance": "الامتثال",

  // Provider KPI
  "kpi.title": "مؤشرات أداء مزودي الخدمة",
  "kpi.subtitle": "تقييم الامتثال بناءً على إنجاز نطاق عقود الصيانة الشاملة ومعدل الالتزام باتفاقيات مستوى الخدمة. المؤشر المركب = 60% إنجاز + 40% SLA.",
  "kpi.score": "درجة مؤشر الأداء",
  "kpi.completion": "الإنجاز",
  "kpi.slaHit": "SLA",
  "kpi.overdue": "متأخرة",
  "kpi.aiEval": "تقييم بالذكاء الاصطناعي",

  // Custom Reports
  "creport.title": "التقارير المخصصة",
  "creport.subtitle": "إنشاء وحفظ وتنزيل وطباعة تقارير PDF مميزة بعلامتك التجارية مع ترويسة الشركة.",
  "creport.new": "تقرير جديد",
  "creport.noSaved": "لا توجد تقارير محفوظة بعد",

  // Help
  "help.title": "دليل المستخدم",
  "help.subtitle": "خطوات سير العمل وأدلة التدريب وجهات الاتصال للدعم",

  // Brand
  "brand.tagline": "من تطبيقات SKG",
  "brand.appName": "إف إم فليكسي برو",

  // Auth
  "auth.signInTitle": "تسجيل الدخول إلى مساحة العمل",
  "auth.signInSubtitle": "استخدم بيانات الاعتماد المقدمة من المسؤول الخاص بك.",
  "auth.password": "كلمة المرور",
  "auth.continueWithGoogle": "المتابعة باستخدام Google",
  "auth.signInWithEmail": "الدخول بالبريد الإلكتروني",
  "auth.tryDemo": "تجربة العرض التوضيحي (للقراءة فقط)",
  "auth.firstLoginNote": "إذا كانت هذه أول مرة تسجل فيها الدخول، فسيُطلب منك تعيين كلمة مرور جديدة.",
  "auth.changePasswordTitle": "تعيين كلمة مرور جديدة",
  "auth.changePasswordSubtitle": "حسابك يستخدم كلمة مرور مؤقتة. يُرجى تعيين كلمة مرور دائمة للمتابعة.",
  "auth.currentPassword": "كلمة المرور الحالية",
  "auth.newPassword": "كلمة المرور الجديدة",
  "auth.confirmPassword": "تأكيد كلمة المرور الجديدة",
  "auth.savePassword": "حفظ كلمة المرور الجديدة",
  "auth.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "auth.passwordMinLength": "يجب ألا تقل كلمة المرور عن 8 أحرف.",
  "auth.signedInAs": "مسجل الدخول باسم",

  // Navigation / Modules — UAE FM industry MSA
  "nav.dashboard": "لوحة التحكم",
  "nav.myWork": "عملي / مؤشرات الفني",
  "nav.buildings": "المباني",
  "nav.assets": "الأصول والمعدات",
  "nav.complaints": "الشكاوى والبلاغات",
  "nav.ppm": "الصيانة الوقائية",
  "nav.schedules": "الجداول الزمنية",
  "nav.analytics": "التحليلات",
  "nav.staff": "الموظفون",
  "nav.attendance": "الحضور والانصراف",
  "nav.contacts": "جهات الاتصال",
  "nav.notices": "التعميمات والإشعارات",
  "nav.sops": "إجراءات التشغيل واتفاقيات الخدمة",
  "nav.serviceReports": "تقارير الخدمة",
  "nav.suppliers": "الموردون",
  "nav.amcContracts": "عقود الصيانة الشاملة",
  "nav.providerKpi": "مؤشرات أداء المزودين",
  "nav.workOrders": "أوامر العمل",
  "nav.technicianKpi": "مؤشرات أداء الفنيين",
  "nav.executive": "لوحة المدير التنفيذي",
  "nav.finance": "اللوحة المالية",
  "nav.purchases": "المشتريات",
  "nav.stock": "المخزون",
  "nav.stockMovements": "سجل حركة المخزون",
  "nav.tenants": "المستأجرون",
  "nav.certificates": "الشهادات",
  "nav.utilities": "المرافق العامة",
  "nav.aiInsights": "رؤى الذكاء الاصطناعي",
  "nav.accounting": "المحاسبة",
  "nav.hr": "الموارد البشرية",
  "nav.users": "المستخدمون",
  "nav.companies": "الشركات",
  "nav.customReports": "تقارير مخصصة",
  "nav.auditLogs": "سجل التدقيق",
  "nav.backups": "النسخ الاحتياطية",
  "nav.roleAccess": "صلاحيات الأدوار",
  "nav.subscription": "الاشتراك",
  "nav.help": "دليل المستخدم",
  "nav.settings": "الإعدادات",
  "nav.more": "المزيد",
  "nav.superadmin": "لوحة المسؤول الأعلى",
  "nav.notes": "الملاحظات والتذكيرات",
  "nav.advAccounting": "المحاسبة المتقدمة",
  "nav.quotations": "عروض الأسعار",
  "nav.vouchers": "السندات المالية",
  "nav.lpo": "إعداد أمر الشراء المحلي",
  "nav.procurement": "التسليم والمدفوعات",
  "nav.spDashboard": "لوحة المبيعات والمشتريات",
  "nav.ppmCalendar": "تقويم الصيانة الوقائية",
  "nav.housekeeping": "التنظيف والإدارة",
  "nav.jobOrders": "أوامر العمل",
  "nav.supplierDashboard": "لوحة الموردين",
  "nav.vault": "خزينة المستندات",
  "nav.workflows": "تدفقات العمل",

  // Menu group headers
  "group.overview": "نظرة عامة",
  "group.complaintWorkflow": "سير عمل الشكاوى",
  "group.operations": "العمليات",
  "group.people": "الموارد البشرية",
  "group.finance": "الشؤون المالية",
  "group.procurement": "المشتريات",
  "group.security": "الأمن",
  "group.compliance": "الامتثال والمطابقة",
  "nav.secIncidents": "الحوادث",
  "nav.secPatrols": "سجل الدوريات",
  "nav.secVisitors": "سجل الزوار",
  "nav.secMaintVisits": "زيارات الصيانة",
  "nav.secKeys": "سجل المفاتيح",
  "group.insights": "التحليلات والرؤى",
  "group.admin": "الإدارة",

  // Common tab labels
  "tab.invoices": "الفواتير",
  "tab.bills": "فواتير الموردين",
  "tab.payments": "المدفوعات",
  "tab.aging": "تقرير الأعمار",
  "tab.leaves": "طلبات الإجازة",
  "tab.payroll": "الرواتب",
  "tab.accounts": "البنك والنقدية",
  "tab.coa": "دليل الحسابات",
  "tab.advances": "الدفعات المقدمة",
  "tab.returns": "مرتجعات المشتريات",
  "tab.pnl": "الأرباح والخسائر",
  "tab.notes": "الملاحظات",
  "tab.reminders": "التذكيرات",
  "tab.complaintFlow": "دورة حياة الشكوى",
  "tab.providerFlow": "صيانة مزود الخدمة",

  // Accounting page
  "accounting.subtitle": "الفواتير وفواتير الموردين والمدفوعات وسلامة التدفق النقدي.",
  "accounting.ar": "الذمم المدينة",
  "accounting.arOverdue": "ذمم مدينة متأخرة",
  "accounting.ap": "الذمم الدائنة",
  "accounting.apOverdue": "ذمم دائنة متأخرة",
  "accounting.invoicesCount": "{{count}} فاتورة · {{outstanding}} مستحقة",
  "accounting.billsCount": "{{count}} فاتورة مورد · {{outstanding}} مستحقة",
  "accounting.pastDueInvoices": "فواتير مستحقة الدفع",
  "accounting.owedPastDue": "مستحقات متأخرة",
  "accounting.noInvoices": "لا توجد فواتير بعد.",
  "accounting.noBills": "لا توجد فواتير موردين بعد.",
  "accounting.noPayments": "لا توجد مدفوعات مسجلة.",
  "accounting.loading": "جارٍ التحميل…",
  "accounting.allBuildings": "جميع المباني",
  "accounting.dateFrom": "من تاريخ",
  "accounting.dateTo": "إلى تاريخ",
  "accounting.clearFilters": "مسح الفلاتر",
  "accounting.recordPayment": "تسجيل دفعة",
  "accounting.markPaid": "تعليم كمدفوع",
  "accounting.newSupplierBill": "فاتورة مورد جديدة",
  "accounting.recordPaymentTitle": "تسجيل دفعة",
  "accounting.invoiceNumber": "رقم الفاتورة",
  "accounting.billNumber": "رقم فاتورة المورد",
  "accounting.customer": "العميل",
  "accounting.supplier": "المورد",
  "accounting.building": "المبنى",
  "accounting.issueDate": "تاريخ الإصدار",
  "accounting.dueDate": "تاريخ الاستحقاق",
  "accounting.amount": "المبلغ",
  "accounting.tax": "الضريبة",
  "accounting.description": "الوصف",
  "accounting.method": "طريقة الدفع",
  "accounting.reference": "المرجع",
  "accounting.directionIn": "واردة (دفعة فاتورة)",
  "accounting.directionOut": "صادرة (دفعة مورد)",
  "accounting.directionLabel": "الاتجاه",
  "accounting.method.bank": "تحويل بنكي",
  "accounting.method.cash": "نقدي",
  "accounting.method.card": "بطاقة",
  "accounting.method.cheque": "شيك",
  "accounting.arAging": "أعمار الذمم المدينة",
  "accounting.apAging": "أعمار الذمم الدائنة",
  "accounting.aging.current": "جاري",
  "accounting.aging.1_30": "1–30 يومًا",
  "accounting.aging.31_60": "31–60 يومًا",
  "accounting.aging.61_90": "61–90 يومًا",
  "accounting.aging.over_90": "أكثر من 90 يومًا",
  // Table headers
  "th.number": "الرقم",
  "th.customer": "العميل",
  "th.supplier": "المورد",
  "th.issue": "تاريخ الإصدار",
  "th.due": "الاستحقاق",
  "th.total": "الإجمالي",
  "th.paid": "المدفوع",
  "th.status": "الحالة",
  "th.date": "التاريخ",
  "th.direction": "الاتجاه",
  "th.reference": "المرجع",
  "th.method": "طريقة الدفع",
  "th.amount": "المبلغ",
  "th.employee": "الموظف",
  "th.type": "النوع",
  "th.from": "من",
  "th.to": "إلى",
  "th.days": "الأيام",
  "th.reason": "السبب",
  "th.monthYear": "الشهر/السنة",
  "th.basic": "الراتب الأساسي",
  "th.allowances": "البدلات",
  "th.ot": "ساعات إضافية",
  "th.deductions": "الخصومات",
  "th.net": "الصافي",
  // Status badges
  "status.draft": "مسودة",
  "status.sent": "مرسلة",
  "status.paid": "مدفوعة",
  "status.overdue": "متأخرة",
  "status.partial": "مدفوعة جزئيًا",
  "status.unpaid": "غير مدفوعة",
  "status.cancelled": "ملغاة",
  "status.pending": "قيد المراجعة",
  "status.approved": "معتمدة",
  "status.rejected": "مرفوضة",
  "status.in": "وارد",
  "status.out": "صادر",
  // HR page
  "hr.subtitle": "طلبات الإجازة والرواتب وعمليات الموارد البشرية.",
  "hr.requestLeave": "طلب إجازة",
  "hr.newPayroll": "سجل راتب جديد",
  "hr.pendingLeaves": "الإجازات المعلقة",
  "hr.awaitingDecision": "بانتظار القرار",
  "hr.approvedYtd": "أيام الإجازة المعتمدة (السنة حتى الآن)",
  "hr.totalRequests": "{{count}} إجمالي الطلبات",
  "hr.payrollYtd": "إجمالي الرواتب المدفوعة (السنة حتى الآن)",
  "hr.recordsThisYear": "{{count}} سجل هذه السنة",
  "hr.pendingPayroll": "رواتب قيد الاعتماد",
  "hr.awaitingApproval": "بانتظار الاعتماد",
  "hr.noLeaves": "لا توجد طلبات إجازة.",
  "hr.noPayroll": "لا توجد سجلات رواتب.",
  "hr.requestLeaveTitle": "طلب إجازة",
  "hr.newPayrollTitle": "سجل راتب جديد",
  "hr.leaveType": "نوع الإجازة",
  "hr.reason": "السبب",
  "hr.month": "الشهر",
  "hr.year": "السنة",
  "hr.basicSalary": "الراتب الأساسي",
  "hr.netSalaryPreview": "صافي الراتب سيكون: ",
  "hr.leaveTypes.annual": "سنوية",
  "hr.leaveTypes.sick": "مرضية",
  "hr.leaveTypes.unpaid": "بدون راتب",
  "hr.leaveTypes.casual": "عارضة",
  "hr.leaveTypes.other": "أخرى",
  "hr.saving": "جارٍ الحفظ…",

  // Common action/page labels
  "common.newInvoice": "فاتورة جديدة",
  "common.newBill": "فاتورة مورد جديدة",
  "common.addNew": "إضافة جديد",
  "common.edit": "تعديل",
  "common.delete": "حذف",
  "common.view": "عرض",
  "common.download": "تنزيل",
  "common.downloadPdf": "تنزيل PDF",
  "common.duplicate": "نسخ",
  "common.approve": "اعتماد",
  "common.reject": "رفض",
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.search": "بحث",
  "common.filter": "تصفية",
  "common.status": "الحالة",
  "common.date": "التاريخ",
  "common.amount": "المبلغ",
  "common.total": "الإجمالي",
  "common.actions": "الإجراءات",
  "common.notes": "ملاحظات",

  // Roles — formal Gulf business titles
  "role.SUPERADMIN": "المسؤول الأعلى",
  "role.FULL_ACCESS": "مسؤول المستخدمين (صلاحيات كاملة)",
  "role.ADMIN": "مسؤول",
  "role.CEO": "الرئيس التنفيذي",
  "role.MANAGER": "المدير",
  "role.ACCOUNTANT": "المحاسب",
  "role.PROCUREMENT_OFFICER": "موظف المشتريات",
  "role.HR_MANAGER": "مدير الموارد البشرية",
  "role.STOREKEEPER": "أمين المخزن",
  "role.SECURITY_OFFICER": "موظف الأمن",
  "role.CS_SUPERVISOR": "مشرف خدمة العملاء",
  "role.ENGINEER": "مهندس / مشرف",
  "role.TECHNICIAN": "فني",
  "role.TENANT": "المستأجر",

  // Settings
  "settings.title": "إعدادات الشركة",
  "settings.subtitle": "تفاصيل الشركة والعلامة التجارية (يظهر الشعار في جميع تقارير PDF)",
  "settings.branding": "العلامة التجارية",
  "settings.companyLogo": "شعار الشركة",
  "settings.uploadLogo": "رفع الشعار",
  "settings.logoHint": "بصيغة PNG أو JPG · حد أقصى 500 كيلوبايت · يُستحسن استخدام شعار مربع",
  "settings.language": "اللغة والتعريب",
  "settings.enableArabic": "تفعيل اللغة العربية (English)",
  "settings.arabicHelp": "عند التفعيل، سيظهر زر تبديل اللغة في الشريط العلوي لجميع مستخدمي الشركة، ويمكنهم استخدام التطبيق باللغة العربية الفصحى الحديثة مع تخطيط من اليمين إلى اليسار. كما ستستجيب رؤى الذكاء الاصطناعي باللغة المختارة.",
  "settings.companyDetails": "تفاصيل الشركة",
  "settings.companyName": "اسم الشركة",
  "settings.address": "العنوان",
  "settings.contactEmail": "البريد الإلكتروني للتواصل",
  "settings.contactPhone": "هاتف التواصل",
  "settings.plan": "الباقة",
  "settings.currencyCode": "رمز العملة",
  "settings.displaySymbol": "رمز العرض",
  "settings.saveSettings": "حفظ الإعدادات",

  // Users
  "users.title": "إدارة المستخدمين",
  "users.subtitle": "إنشاء حسابات الموظفين (مشرف، أمن، مهندس، مدير، إلخ) — يُولِّد النظام كلمة مرور لمرة واحدة تلقائيًا.",
  "users.createUser": "إنشاء مستخدم",
  "users.createStaffAccount": "إنشاء حساب موظف",
  "users.tempPasswordHint": "سيتم توليد كلمة مرور مؤقتة تلقائيًا. شاركها مع المستخدم — سيقوم بتغييرها عند أول تسجيل دخول.",
  "users.fullName": "الاسم الكامل",
  "users.createGenerate": "إنشاء وتوليد كلمة مرور مؤقتة",
  "users.accountCreated": "تم إنشاء الحساب",
  "users.savePasswordWarning": "احفظ كلمة المرور المؤقتة الآن. لن تظهر مرة أخرى. شاركها مع المستخدم — يجب عليه تغييرها عند أول تسجيل دخول.",
  "users.tempPassword": "كلمة المرور المؤقتة",
  "users.copyLoginDetails": "نسخ بيانات تسجيل الدخول",
  "users.savedClose": "تم حفظها — إغلاق",
  "users.resetPassword": "إعادة تعيين كلمة المرور",
  "users.blockUser": "حظر المستخدم",
  "users.unblockUser": "إلغاء الحظر",
  "users.deleteUser": "حذف المستخدم",
  "users.tempBadge": "مؤقتة",
  "users.noUsers": "لا يوجد مستخدمون بعد",
  "users.confirmBlock": "هل تريد حظر هذا المستخدم؟ سيتم تسجيل خروجه ولن يتمكن من تسجيل الدخول.",
  "users.confirmReset": "هل تريد توليد كلمة مرور مؤقتة جديدة؟ سيتم تسجيل خروج المستخدم وإجباره على تغييرها عند تسجيل الدخول التالي.",
  "users.confirmDelete": "هل تريد حذف هذا المستخدم؟ لا يمكن التراجع عن هذا الإجراء.",

  // Language
  "lang.english": "English",
  "lang.arabic": "العربية",
  "lang.switchTo": "تبديل اللغة",
};

export default ar;
